import { render, staticRenderFns } from "./ExCriteriaInstructionsCell.vue?vue&type=template&id=4ca354f2"
import script from "./ExCriteriaInstructionsCell.vue?vue&type=script&lang=js"
export * from "./ExCriteriaInstructionsCell.vue?vue&type=script&lang=js"
import style0 from "./ExCriteriaInstructionsCell.vue?vue&type=style&index=0&id=4ca354f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports